<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="asset_owner"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="assetOwnerForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Pemilik Asset Listing"
          addButton="Pemilik Asset Konsumen"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          hide-footer
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Input Group Konsumen Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Group Konsumen</h3>
          </div>

          <b-form id="assetOwnerForm" validated novalidate @submit="saveProcess">
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="owner" label="Nama Pemilik">
                    <b-form-input
                      id="owner"
                      type="text"
                      v-model="$v.assetOwnerForm.owner.$model"
                      :state="!$v.assetOwnerForm.owner.$invalid"
                      required
                      placeholder="Nama pemilik"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama pemilik harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Nama Barang">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.assetOwnerForm.name.$model"
                      :state="!$v.assetOwnerForm.name.$invalid"
                      required
                      placeholder="Nama barang"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama barang harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="description" label="Deskripsi">
                    <b-form-textarea
                      id="description"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.assetOwnerForm.description.$model"
                      :state="!$v.assetOwnerForm.description.$invalid"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <div class="float-right">
                <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                  <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
                <b-button
                  type="submit"
                  size="sm"
                  variant="primary"
                  :disabled="$v.assetOwnerForm.$invalid"
                >
                  <i class="fa fa-save"></i> Save
                </b-button>
              </div>
            </div>
            
            <div v-else>
              <loading></loading>
            </div>
          </b-form>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "asset_owner",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      asset_owner: [],
      loading: true,
      loadingSubmitModal: false,
      fields: [
        { key: "owner", label: "Nama Pemilik", sortable: true },
        { key: "name", label: "Nama Barang", sortable: true },
        { key: "description", label: "Deskripsi" },
        { key: "action", class: "text-center width-80" }
      ],
      assetOwnerForm: masterInterfaces.asset_owner,
      isEdit: false
    };
  },
  validations: {
    assetOwnerForm: {
      owner: { required },
      name: { required },
      description: {}
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.getAssetOwner();
    },
    getAssetOwner: function() {
      this.axios
        .get("web/master/assets/asset_owner/all/")
        .then(response => {
          this.asset_owner = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function(e) {
      this.isEdit = true;
      this.assetOwnerForm = e;
    },
    resetForm: function() {
      for (var a in masterInterfaces.asset_owner) {
        masterInterfaces.asset_owner[a] = null;
      }
      this.assetOwnerForm = masterInterfaces.asset_owner;
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah group konsumen ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put("web/master/assets/asset_owner/edit/", this.assetOwnerForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Group Konsumen",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, "Ubah Group Konsumen");
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan group konsumen ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .post("web/master/assets/asset_owner/add/", this.assetOwnerForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Group Konsumen",
                  message: response.data.message
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Group Konsumen",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, "Tambah Group Konsumen");
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

  